<template>
    <div class="pagination">
        <typo v-if="totalConventions" name="body-14-normal" class="pagination-text">
            {{ showingFrom }} - {{ showingTo }} de {{ totalConventions }}
        </typo>
        <v-pagination
            :value="pageNumber + 1"
            @input="onInput"
            :length="numberOfPages || 32"
            :total-visible="11"
        />
    </div>
</template>

<script>
import { min } from "lodash";
export default {
    props: ["totalConventions", "pageNumber", "numberOfPages", "pageSize"],
    methods: {
        onInput(value) {
            this.$emit("change", value - 1);
        },
    },
    computed: {
        showingFrom() {
            return this.pageNumber * this.pageSize + 1;
        },
        showingTo() {
            const to = this.pageNumber * this.pageSize + this.pageSize;
            return min([to, this.totalConventions]);
        },
    },
};
</script>

<style lang="sass" scoped>
.pagination
    display: flex
    align-items: center
    justify-content: center

.pagination-text
    padding-right: 16px
</style>
